<template>
    <div class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">
            <header style="display: flex; ">
                <div>
                    <v-tooltip text="Regresar" location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn 
                                v-bind="props"  
                                class="text-none ml-4 mt-1"
                                @click="goBack()"
                                color="indigo-darken-3"
                                icon="mdi-arrow-left" 
                                hide-details
                                size="small" 
                            ></v-btn>
                        </template>
                    </v-tooltip>

                </div>
                <div>
                    <v-card-title>Gestión de Subcategorías</v-card-title>
                </div>
            </header>
            <v-divider class="mx-3"></v-divider>

            <div class="content_accion">
                <div>
                    <v-text-field
                        v-model="search"
                        label="Búsqueda"
                        prepend-inner-icon="mdi-magnify"
                        single-line
                        variant="outlined"
                        hide-details
                        class="filter"
                    ></v-text-field>
                </div>
                <div>
                    <v-tooltip text="Recargar" location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn 
                                v-bind="props"
                                class="mr-2"
                                size="small" 
                                icon="mdi-reload" 
                                variant="outlined" 
                                color="indigo-darken-3" 
                                @click="getSubcategories()"
                            ></v-btn>
                        </template>
                    </v-tooltip>
                    <v-btn 
                        v-if="permission.addSubcategory"
                        prepend-icon="mdi-plus" 
                        color="indigo-darken-3"
                        class="elevation-0 text-none mr-2"
                        text="Registrar"
                        @click="openForm('R')"
                    ></v-btn>
                </div>
            </div>

            <div class="container_table">
                <v-data-table
                    v-if="permission.readSubcategory"
                    :headers="dataSource.headers"
                    :items="dataSource.data"
                    :search="search"
                    :loading="isLoading"
                    fixed-header
                    class="content_table"
                    no-data-text="Sin datos para mostrar"
                    loading-text="Cargando información... Espere un momento"
                >
                    <template v-slot:[`item.actions`]="{ item }">
                        <td>
                            <v-tooltip text="Editar" location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        v-if="permission.editSubcategory"
                                        v-bind="props"
                                        class="elevation-0 mr-1"
                                        density="comfortable" 
                                        icon="mdi-pencil" 
                                        color="indigo-darken-3"
                                        @click="openForm('M', item)">
                                    </v-btn>
                                </template>
                            </v-tooltip>

                            <v-tooltip text="Eliminar" location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        v-if="permission.deteleSubcategory"
                                        v-bind="props"
                                        class="elevation-0"
                                        density="comfortable" 
                                        icon="mdi-delete" 
                                        color="error" 
                                        @click="confirmateDelete(item)"
                                    ></v-btn>
                                </template>
                            </v-tooltip>
                        </td>
                    </template>
                </v-data-table>
            </div>
        </v-card>

        <template>
            <v-dialog
                v-model="dataDialogForm.open"
                activator="parent"
                persistent
                width="500px">
                <v-card>
                    <header>
                        <v-card-title class="text-h5">{{ dataDialogForm.title }}</v-card-title>
                        <v-divider class="mx-3"></v-divider>
                    </header>
                    <form class="mt-4 px-4 override_content_flex">
                        <div class="col-flex-12">
                            <v-select
                                label="Categoría"
                                v-model="formGroup.data.id_categoria"
                                :rules="formGroup.rules.id_categoria"
                                variant="outlined"
                                :items="arrCategory"
                                item-title="nombre_categoria"
                                item-value="id_categoria"
                                class="w-100"
                            ></v-select>
                        </div>
                        <div class="col-flex-12">
                            <v-text-field  
                                label="Nombre de la Subcategoría" 
                                v-model="formGroup.data.nombre_subcategoria"
                                :rules="formGroup.rules.nombre_subcategoria"
                                variant="outlined"
                                class="w-100"
                            ></v-text-field>
                        </div>
                        <div class="col-flex-12">
                            <v-textarea 
                                label="Descripción de la Subcategoría"
                                v-model="formGroup.data.descripcion_subcategoria"
                                :rules="formGroup.rules.descripcion_subcategoria"
                                variant="outlined"
                                class="w-100"
                                rows="3"
                            ></v-textarea>
                        </div>
                    </form>
                    <v-card-actions class="actions_buttons">
                        <v-btn 
                            variant="flat"
                            color="red"
                            class="text-none"
                            text="Cerrar"
                            prepend-icon="mdi-close"
                            @click="clearForm()"
                        ></v-btn>
                        <v-btn 
                            variant="flat"
                            color="indigo-darken-3"
                            class="text-none"
                            text="Guardar"
                            prepend-icon="mdi-content-save"
                            :disabled="validateForm()"
                            @click="saveForm()"
                        ></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

        <template>
            <v-dialog v-model="dataDialogSave.open" width="auto" persistent>
                <v-card>
                    <v-card-title text-h5>{{ dataDialogSave.title }}</v-card-title>
                    <v-card-text>
                        <div class="text-center alert_img" v-if="!dataDialogSave.loading">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <div class="content_load" v-if="dataDialogSave.loading">
                            <v-progress-circular
                                :size="100"
                                :width="7"
                                color="indigo-darken-3"
                                indeterminate
                            ></v-progress-circular>
                            <i>Espere un momento</i>
                        </div>

                        <div class="description-text">
                            <p>{{ dataDialogSave.description }}</p>
                        </div>
                    </v-card-text>
                    <v-card-actions class="actions_buttons_confirmation">
                        <v-btn 
                            variant="flat"
                            color="red"
                            class="text-none"
                            text="Cancelar"
                            prepend-icon="mdi-cancel"
                            @click="clearForm()"
                        ></v-btn>
                        <v-btn 
                            variant="flat"
                            color="indigo-darken-3"
                            class="text-none"
                            text="Aceptar"
                            prepend-icon="mdi-check"
                            @click="confirmateForm()"
                        ></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>                
        </template>

        <template>
            <v-dialog v-model="dataAlertDelete.open" width="auto" persistent>
                <v-card>
                    <v-card-title text-h5>Confirmación</v-card-title>
                    <v-card-text>
                        <div class="text-center alert_img" v-if="!dataAlertDelete.loading">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <div class="content_load" v-if="dataAlertDelete.loading">
                            <v-progress-circular
                                :size="100"
                                :width="7"
                                color="indigo-darken-3"
                                indeterminate
                            ></v-progress-circular>
                            <i>Espere un momento</i>
                        </div>

                        <div class="description-text">
                            <p>¿Está seguro de eliminar la subcategoría?</p>
                        </div>
                    </v-card-text>
                    <v-card-actions class="actions_buttons_confirmation">
                        <v-btn 
                            variant="flat"
                            color="red"
                            class="text-none"
                            text="Cancelar"
                            prepend-icon="mdi-cancel"
                            @click="dataAlertDelete.open = false"
                        ></v-btn>
                        <v-btn 
                            variant="flat"
                            color="indigo-darken-3"
                            class="text-none"
                            text="Aceptar"
                            prepend-icon="mdi-check"
                            @click="deleteSubcategoryDocument()"
                        ></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>                
        </template>

        <SnackbarComponent :value="snackbarData"/>
    </div>
</template>

<script>
import { DocumentsService } from '@/services/DocumentsService'
import { EncryptService } from '@/services/EncryptService'

export default {
    name: "SubcategoryView",
    props: {
        msg: String,
    },
    data() {
        return {
            search: '',
            isLoading: false,
            dataSource: {
                data: [],
                headers: [
                    { align: 'start', key: 'id_categoria', title: 'ID Categoría' },
                    { key: 'id_subcategoria', title: 'ID Subcategoría' },
                    { key: 'nombre_subcategoria', title: 'Nombre de la Subcategoría' },
                    { key: 'descripcion_subcategoria', title: 'Descripción de la Subcategoría' },
                    { key: 'agregado_por', title: 'Última Actualización' },
                    { key: 'created_at', title: 'Fecha de Actualización' },
                    { key: 'actions', title: 'Acciones' },
                ],
            },
            arrCategory: [],
            formGroup: {
                data: {
                    id_categoria: null,
                    nombre_subcategoria: null,
                    descripcion_subcategoria: null,
                },
                rules: {
                    id_categoria: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Categoría es requerido`
                            }
                            return true
                        }
                    ],
                    nombre_subcategoria: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Nombre de la Categoría es requerido`
                            }
                            return true
                        }
                    ],
                    descripcion_subcategoria: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Descripción de la Categoría es requerido`
                            }
                            return true
                        }
                    ],
                }
            },
            dataDialogForm: {
                type: 'R' | 'M',
                title: '',
                open: false,
                id: null,
            },
            dataAlertDelete: {
                id: null,
                open: false,
                loading: false,
            },
            dataDialogSave: {
                title: '',
                description: '',
                loading: false,
                open: false
            },
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            permission: {
                readSubcategory: false,
                addSubcategory: false,
                editSubcategory: false,
                deteleSubcategory: false,
            },
        }
    },
    async created() {
        const ENC_PERMISOS = localStorage.getItem('PERMISOS')
        const STR_PERMISOS = atob(ENC_PERMISOS)
        const ARR_PERMISOS = JSON.parse(STR_PERMISOS)
        const PERMISSION = ARR_PERMISOS.find((permission) => permission.modulo === 'M04DOCU')
        for (const element of PERMISSION.endpoints) {
            if (element.nombre === 'M06F2COSC' && element.permiso === true) {
                this.permission.readSubcategory = true
            }
            if (element.nombre === 'M06F2AGSC' && element.permiso === true) {
                this.permission.addSubcategory = true
            }
            if (element.nombre === 'M06F2EDSC' && element.permiso === true) {
                this.permission.editSubcategory = true
            }
            if (element.nombre === 'M06F2ELSC' && element.permiso === true) {
                this.permission.deteleSubcategory = true
            }
        }

        this.isLoading = true
        await this.getCategories()
        await this.getSubcategories()
        this.isLoading = false
    },
    methods: {
        getSubcategories: async function () {
            this.isLoading = true
            await DocumentsService.getSubcategories().then(
                (responseData) => {
                    if (!responseData.error) {
                        let arrTemp = []
                        for (let element of responseData.response) {
                            
                            element.id_categoria = element.id_categoria === null ? 'N/A' : element.id_categoria
                            element.id_subcategoria = element.id_subcategoria === null ? 'N/A' : element.id_subcategoria
                            element.nombre_subcategoria = element.nombre_subcategoria === null ? 'N/A' : element.nombre_subcategoria
                            element.descripcion_subcategoria = element.descripcion_subcategoria === null ? 'N/A' : element.descripcion_subcategoria

                            element.agregado_por = element.editado_por === null ? element.agregado_por : element.editado_por
                            element.created_at = element.updated_at === null ? element.created_at : element.updated_at

                            arrTemp.push(element)
                        }
                        this.dataSource.data = arrTemp

                    } else {
                        this.snackbarData.description = `${responseData.msg}`
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
        getCategories: async function () {
            this.isLoading = true
            await DocumentsService.getCategories().then(
                async (responseData) => {
                    if (!responseData.error) {
                        this.arrCategory = responseData.response
                    } else {
                        this.snackbarData.description = `${responseData.msg}`
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },

        openForm: function (typeForm, item) {
            this.dataDialogForm.type = typeForm
            if (typeForm === 'R') {
                this.dataDialogForm.title = `Registro de Subcategoría`
                this.dataDialogForm.open = true

            } else if (typeForm === 'M') {
                this.dataDialogForm.title = `Modificación de Subcategoría`
                this.dataDialogForm.id = item.id_subcategoria
                this.formGroup.data.id_categoria = item.id_categoria
                this.formGroup.data.nombre_subcategoria = item.nombre_subcategoria
                this.formGroup.data.descripcion_subcategoria = item.descripcion_subcategoria
                this.dataDialogForm.open = true
            } else {
                this.snackbarData.description = `Opción no disponible`
                this.snackbarData.openSnackbar = true
            }
        },

        validateForm: function () {
            let id_categoria = this.formGroup.data.id_categoria
            if (id_categoria === null || id_categoria === undefined || id_categoria === '') {
                return true
            }
            let nombre_subcategoria = this.formGroup.data.nombre_subcategoria
            if (nombre_subcategoria === null || nombre_subcategoria === undefined || nombre_subcategoria === '') {
                return true
            }
            let descripcion_subcategoria = this.formGroup.data.descripcion_subcategoria
            if (descripcion_subcategoria === null || descripcion_subcategoria === undefined || descripcion_subcategoria === '') {
                return true
            }
            return false
        },

        clearForm: function () {
            this.formGroup.data.id_categoria = null
            this.formGroup.data.nombre_subcategoria = null
            this.formGroup.data.descripcion_subcategoria = null
            this.dataDialogForm.open = false
            this.dataDialogSave.open = false
        },

        saveForm: function () {
            const TYPE = this.dataDialogForm.type
            if (TYPE === 'R') {
                this.dataDialogSave.title = `Confirmación`
                this.dataDialogSave.description = `¿Está seguro de registrar la subcategoría?`
                this.dataDialogForm.open = false
                this.dataDialogSave.open = true
            } else if (TYPE === 'M') {
                this.dataDialogSave.title = `Confirmación`
                this.dataDialogSave.description = `¿Está seguro de modificar la subcategoría?`
                this.dataDialogForm.open = false
                this.dataDialogSave.open = true
            } else {
                this.snackbarData.description = `Opción no disponible`
                this.snackbarData.openSnackbar = true
            }
        },

        confirmateForm: async function () {
            this.dataDialogSave.loading = true
            const TYPE = this.dataDialogForm.type
            if (TYPE === 'R') {
                this.dataDialogSave.description = `Registrando el subcatálogo`;
                await this.registerSubcategory()
                this.dataDialogSave.open = false
            } else if (TYPE === 'M') {
                this.dataDialogSave.description = `Modificando el subcatálogo`;
                await this.updateSubcategory()
                this.dataDialogSave.open = false
            } else {
                this.snackbarData.description = `Opción no disponible`
                this.snackbarData.openSnackbar = true
            }
            this.dataDialogSave.loading = false
        },

        registerSubcategory: async function () {
            const REQUEST = await this.createRequestSubcategory()
            if (REQUEST !== null) {
                await DocumentsService.createSubcategoryDocument(REQUEST).then(
                    async (responseData) => {
                        if (!responseData.error) {
                            this.snackbarData.description = `¡Registro de Subcategoría Exitosa!`
                            this.snackbarData.openSnackbar = true
                            await this.getSubcategories()
                        } else {
                            this.snackbarData.description = `${responseData.msg}`
                            this.snackbarData.openSnackbar = true
                        }
                    }
                )
            }
        },

        updateSubcategory: async function () {
            const REQUEST = await this.createRequestSubcategory()
            const ID = this.dataDialogForm.id
            if (REQUEST !== null && ID !== null) {
                const ENC_ID = await EncryptService.encrypt(`${ID}`)
                await DocumentsService.editSubcategoryDocument(ENC_ID, REQUEST).then(
                    async (responseData) => {
                        if (!responseData.error) {
                            this.snackbarData.description = `!Modificación de Subcategoría Exitosa!`
                            this.snackbarData.openSnackbar = true
                            await this.getSubcategories()
                        } else {
                            this.snackbarData.description = `${responseData.msg}`
                            this.snackbarData.openSnackbar = true
                        }
                    }
                )
            } else {
                this.snackbarData.description = `Datos incorrectos`
                this.snackbarData.openSnackbar = true
            }
        },

        createRequestSubcategory: async function () {
            let id_categoria = this.formGroup.data.id_categoria
            id_categoria = id_categoria.toString().trim();
            id_categoria = await EncryptService.encrypt(`${id_categoria}`)

            let nombre_subcategoria = this.formGroup.data.nombre_subcategoria
            nombre_subcategoria = nombre_subcategoria.toString().trim();

            let descripcion_subcategoria = this.formGroup.data.descripcion_subcategoria
            descripcion_subcategoria = descripcion_subcategoria.toString().trim();

            const USERNAME = localStorage.getItem('USERNAME')

            let requestForm = {
                id_categoria: id_categoria,
                nombre_subcategoria: nombre_subcategoria,
                descripcion_subcategoria: descripcion_subcategoria,
            }
            if (this.dataDialogForm.type === 'R') {
                requestForm.agregado_por = USERNAME
            } else if (this.dataDialogForm.type === 'M') {
                requestForm.editado_por = USERNAME
            } else {
                this.snackbarData.description = `Opción no disponible`
                this.snackbarData.openSnackbar = true
                return null
            }

            return requestForm
        },

        confirmateDelete: function (item) {
            this.dataAlertDelete.id = item.id_subcategoria
            this.dataAlertDelete.open = true
        },

        deleteSubcategoryDocument: async function () {
            this.dataAlertDelete.loading = true
            const ID = this.dataAlertDelete.id
            if (ID !== null) {
                const ENC_ID = await EncryptService.encrypt(`${ID}`)
                await DocumentsService.deleteSubcategoryDocument(ENC_ID).then(
                    (responseData) => {
                        if (!responseData.error) {
                            this.snackbarData.description = `!Eliminación de Subcategoría Exitosa!`
                            this.snackbarData.openSnackbar = true
    
                            this.dataAlertDelete.id = null
                            this.dataAlertDelete.open = false
    
                            this.getSubcategories()
                        } else {
                            this.snackbarData.description = `${responseData.msg}`
                            this.snackbarData.openSnackbar = true
                        }
                    }
                )
            } else {
                this.snackbarData.description = `Datos incorrectos`
                this.snackbarData.openSnackbar = true
            }
            this.dataAlertDelete.loading = false
        },

        goBack: function () {
            window.history.back();
        },

    }
}
</script>

<style scoped>
    
</style>